/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UniversityMaster
 */
export interface UniversityMaster {
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UniversityMaster
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversityMaster
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversityMaster
     */
    nameEn?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversityMaster
     */
    nameLocal?: string;
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    countryId?: number;
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    chinaRankingCategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    chinaRankingPartnerSchoolTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    rankingChina?: number;
    /**
     * 
     * @type {string}
     * @memberof UniversityMaster
     */
    rankingQsAsia?: string;
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    kuRelationshipTypeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UniversityMaster
     */
    isRussellGroup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UniversityMaster
     */
    isGroupOf8: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UniversityMaster
     */
    isInstitutionOfNationalImportance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UniversityMaster
     */
    isInstitutionOfEminence: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UniversityMaster
     */
    excelSpecialNote: boolean;
    /**
     * 
     * @type {number}
     * @memberof UniversityMaster
     */
    securityExportControlTypeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UniversityMaster
     */
    isOther: boolean;
}

export function UniversityMasterFromJSON(json: any): UniversityMaster {
    return UniversityMasterFromJSONTyped(json, false);
}

export function UniversityMasterFromJSONTyped(json: any, ignoreDiscriminator: boolean): UniversityMaster {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nameEn': !exists(json, 'nameEn') ? undefined : json['nameEn'],
        'nameLocal': !exists(json, 'nameLocal') ? undefined : json['nameLocal'],
        'countryId': !exists(json, 'countryId') ? undefined : json['countryId'],
        'chinaRankingCategoryId': !exists(json, 'chinaRankingCategoryId') ? undefined : json['chinaRankingCategoryId'],
        'chinaRankingPartnerSchoolTypeId': !exists(json, 'chinaRankingPartnerSchoolTypeId') ? undefined : json['chinaRankingPartnerSchoolTypeId'],
        'rankingChina': !exists(json, 'rankingChina') ? undefined : json['rankingChina'],
        'rankingQsAsia': !exists(json, 'rankingQsAsia') ? undefined : json['rankingQsAsia'],
        'kuRelationshipTypeId': !exists(json, 'kuRelationshipTypeId') ? undefined : json['kuRelationshipTypeId'],
        'isRussellGroup': json['isRussellGroup'],
        'isGroupOf8': json['isGroupOf8'],
        'isInstitutionOfNationalImportance': json['isInstitutionOfNationalImportance'],
        'isInstitutionOfEminence': json['isInstitutionOfEminence'],
        'excelSpecialNote': json['excelSpecialNote'],
        'securityExportControlTypeId': !exists(json, 'securityExportControlTypeId') ? undefined : json['securityExportControlTypeId'],
        'isOther': json['isOther'],
    };
}

export function UniversityMasterToJSON(value?: UniversityMaster | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'nameEn': value.nameEn,
        'nameLocal': value.nameLocal,
        'countryId': value.countryId,
        'chinaRankingCategoryId': value.chinaRankingCategoryId,
        'chinaRankingPartnerSchoolTypeId': value.chinaRankingPartnerSchoolTypeId,
        'rankingChina': value.rankingChina,
        'rankingQsAsia': value.rankingQsAsia,
        'kuRelationshipTypeId': value.kuRelationshipTypeId,
        'isRussellGroup': value.isRussellGroup,
        'isGroupOf8': value.isGroupOf8,
        'isInstitutionOfNationalImportance': value.isInstitutionOfNationalImportance,
        'isInstitutionOfEminence': value.isInstitutionOfEminence,
        'excelSpecialNote': value.excelSpecialNote,
        'securityExportControlTypeId': value.securityExportControlTypeId,
        'isOther': value.isOther,
    };
}

